<template>
  <DatesBlock
    class="mb-14 rounded-2xl bg-[#E1D5D6] p-2.5 pb-10 pt-4 md:p-5"
    with-calendar
  >
    <template #actions>
      <div class="flex flex-col">
        <NuxtLink
          class="ml-auto block w-fit cursor-pointer self-center whitespace-nowrap text-[18px] font-medium leading-6 text-new-test-black"
          :to="linkDatesPage"
        >
          Развернуть календарь
        </NuxtLink>
      </div>
    </template>
    <template #content>
      <div class="relative">
        <DatesCardSlider
          v-if="dates?.length"
          :data="dates"
          main
          @on-swiper="onSwiper"
        />
        <div v-else class="relative top-35% mx-auto w-fit">
          События не найдены
        </div>
        <SlidersSliderControl
          type="prev"
          class="absolute left-0 top-35% z-10 hidden md:block"
          :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
          @click="slidePrev()"
        />
        <SlidersSliderControl
          type="next"
          class="absolute right-0 top-35% z-10 hidden md:block"
          :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
          @click="slideNext()"
        />
      </div>
    </template>
  </DatesBlock>
</template>

<script setup>
const route = useRoute();
const { onSwiper, slideNext, slidePrev, isBeginning, isEnd } = useSwiper();

/** SORTING DATES*/
const linkDatesPage = computed(() => {
  return {
    name: 'teacher-historical-calendar',
    query: {
      ...route.query,
    },
  };
});

/** DATES DATA */
const days = computed(() => {
  const dateString =
    route.query?.days ||
    new Date().toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: '2-digit',
    });

  if (!dateString) {
    return null;
  }

  if (dateString.includes('-')) {
    const [start, end] = dateString.split('-');
    const startParts = start.split('.');
    const endParts = end.split('.');
    return {
      start_day: startParts[0],
      start_month: Number(startParts[1]),
      end_day: endParts[0],
      end_month: Number(endParts[1]),
    };
  } else {
    const parts = dateString.split('.');
    return {
      start_day: parts[0],
      start_month: Number(parts[1]),
      end_day: parts[0],
      end_month: Number(parts[1]),
    };
  }
});

const filters = computed(() => {
  return {
    category: route.query?.sort,
    ...(days.value && { ...days.value }),
  };
});

const { dateArticles } = useDateArticles({ filters, per_page: 15 });

const dates = computed(() => dateArticles?.data?.value?.data || []);
</script>
